<template>
  <div>
    <!-- 查询条件 -->
    <b-row ref="queryFormWrapper" class="p-2">
      <b-col>
        <b-form inline>
          <b-form-select
            style="min-width:200px;"
            class="m-1"
            :options="orgList"
            v-model="queryParam.orgId"
            v-if="showOrg"
            placeholder="请选择机构"
          ></b-form-select>
          <b-form-select
            style="min-width:130px;"
            class="m-1"
            :options="entList"
            v-model="queryParam.buyerTaxCode"
          ></b-form-select>
          <b-form-select
            class="m-1"
            :options="dateRangeList"
            v-model="queryParam.dateRangeType"
            placeholder="时间类型"
          ></b-form-select>

          <date-range-picker
            ref="picker"
            opens="center"
            :locale-data="{ locale: daterange.local, format: 'yyyy-MM-dd' ,applyLabel:'确定',cancelLabel:'取消'}"
            :ranges="daterange.ranges"
            v-model="queryParam.daterange"
            style="min-width:200px;"
            placeholder="创建日期"
            class="m-1"
          ></date-range-picker>

          <b-button variant="outline-primary" @click="query" class="m-1">查询</b-button>
        </b-form>
      </b-col>
    </b-row>

    <vue-pivottable-ui
      class="mt-1"
      :data="items"
      :rows="['税收分类']"
      :cols="['年','月']"
    >
    </vue-pivottable-ui>

  </div>
</template>

<script>
import { VuePivottableUi } from 'vue-pivottable'
import 'vue-pivottable/dist/vue-pivottable.css'
import * as invoiceStatFacade from "../../../api/invoice-stat-facade.js";
import * as orgFacade from "../../../api/org-facade.js";
import * as entFacade from "../../../api/ent-facade.js";
import { mapState } from "vuex";
import { zhCN } from "date-fns/locale";
import {
  addDays,
  addHours,
  startOfMonth,
  startOfYear,
  endOfMonth,
  addMonths,
  endOfYear,
  startOfWeek,
  endOfWeek,
  addWeeks
} from "date-fns/esm";

export default {
  // validations:
  data() {
    return {
      orgList: [
        { text: "机构", value: "" },
        { text: "机构一", value: "1" }
      ],
      dateRangeList: [
        { text: "开票时间", value: "0" },
        { text: "记账时间", value: "1" },
      ],
      entList: [{ text: "受票方", value: "" }],
      daterange: {
        local: zhCN,
        locale: {
          localize: "zhCN",
          //汉化
          format: "YYYY-MM-DD", //设置显示格式
          applyLabel: "确定", //确定按钮文本
          cancelLabel: "取消", //取消按钮文本
          daysOfWeek: ["日", "一", "二", "三", "四", "五", "六"],
          monthNames: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月"
          ],
          firstDay: 1
        },
        dateFormat: "yyyy-MM-dd",
        ranges: {
          今天: [new Date(), new Date()],
          昨天: [addDays(new Date(), -1), addDays(new Date(), -1)],
          本月: [startOfMonth(new Date()), endOfMonth(new Date())],
          本年: [startOfYear(new Date()), endOfYear(new Date())],
          上一周: [
            addDays(startOfWeek(addWeeks(new Date(), -1)), 1),
            addDays(endOfWeek(addWeeks(new Date(), -1)), 1)
          ],
          上一月: [
            startOfMonth(addMonths(new Date(), -1)),
            endOfMonth(addMonths(new Date(), -1))
          ]
        }
      },

      // 以下为数据展示和传输对象，基本上与后台接口的传输对象一致
      queryParam: {
        orgId: "",
        buyerTaxCode: "",
        dateRangeType: "0",
        daterange: {
          startDate: this.getYearFirstDate(),
          endDate: new Date()
        },
        datePeriod:[],
      },

      items:[],
      // 以上为数据展示和传输对象

      // 以下为页面状态控制参数
      showOrg: false,
      pageLoading: false,

      opIndex: -1, // 当前操作的表格行索引
      // 以上为页面状态控制参数
      // 以下为表单校验规则

      // 以上为表单校验规则
    };
  },
  watch: {
    "queryParam.orgId"() {
      if (this.queryParam.orgId) {
        entFacade
          .findByOrgId(this.queryParam.orgId)
          .then(res => {
            this.parseEntInfo(res);
          })
          .catch(err => {
            console.log("err", err);
            this.pageLoading = false;
          });
      }
    }
  },

  computed: {
    ...mapState("admin/user", ["info"])
  },
  created() {
    this.initInfo();
  },
  mounted() {
    // 异步加载列表数据

    // 异步加载检索条件中的“纳税人”下拉菜单
  },
  methods: {
    getYearFirstDate(){
      var firstDay = new Date()
      firstDay.setMonth(0)
      firstDay.setDate(1)
      return firstDay;
    },

    // 根据查询条件检索数据
    query(){
      // 日期转换
      if (this.queryParam.daterange) {
        this.queryParam.datePeriod[0] = addHours(
          this.queryParam.daterange.startDate,
          8
        );
        this.queryParam.datePeriod[1] = addHours(
          this.queryParam.daterange.endDate,
          8
        );
      }

      this.pageLoading = true; // 打开表格的Loading状态
      invoiceStatFacade
        .olap(this.queryParam) // 异步调用后台接口
        .then(res => {
          this.items = res; // 为表格填充数据
          this.pageLoading = false; // 关闭表格的Loading状态
          if(res.length==0){
            this.$message({
              message: "没有检索到发票信息",
              type: "danger"
            });

          }
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },

    //获取机构信息
    async getOrgInfo() {
      this.pageLoading = true;
      orgFacade
        .findByUserRole()
        .then(res => {
          this.pageLoading = false;
          let orgList = [{ text: "机构", value: "" }];

          res.map(item => {
            let org = {};
            org.text = item.name;
            org.value = item.id;
            orgList.push(org);
          });
          this.orgList = orgList;
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },
    //获取企业信息
    async getEntInfo() {
      this.pageLoading = true;
      entFacade
        .findByUser()
        .then(res => {
          this.parseEntInfo(res);
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },
    //初始化信息
    initInfo() {
      let roles = this.info.roles;
      //系统管理员
      if (roles.indexOf("sys_admin") > -1) {
        this.showOrg = true;
        this.getOrgInfo();
        this.getEntInfo();
      } else {
        //机构管理员或者财务经理
        this.showOrg = false;
        this.getEntInfo();
      }
    },
    //解析企业信息
    parseEntInfo(res) {
      this.pageLoading = false;
      let entList = [{ text: "受票方", value: "" }];
      let accEntList = [];
      if (res) {
        res.map(item => {
          let ent = {};
          ent.text = item.entName;
          ent.value = item.entCode;
          entList.push(ent);
          accEntList.push(ent);
        });
      }

      this.entList = entList;
      this.accEntList = accEntList;
      if (this.accEntList.length > 0) {
        this.accountParam.entCode = this.accEntList[0].value;
      }
    },
  },

  components: {
    VuePivottableUi
  }

};

</script>